import * as XLSX from 'xlsx'

export default function useExportArsopbl() {
  const rightLabels = {
    ACC: 'Acceso',
    RECT: 'Rectificación',
    SUPR: 'Supresión',
    OPO: 'Oposición',
    PORT: 'Portabilidad',
    BLOQ: 'Bloqueo',
    LIMI: 'Limitación',
  }

  const stageLabels = {
    reception: 'Recepción',
    identity_validation: 'Validación de identidad',
    analysis: 'Análisis de procedencia',
    execution: 'Ejecución',
    response: 'Respuesta',
    closure: 'Cierre',
  }

  const statusLabels = {
    open: 'Abierto',
    resolved: 'Resuelto',
    rejected: 'Rechazado',
    desisted: 'Desistido',
  }

  const deadlineLabels = {
    on_time: 'En plazo',
    near_deadline: 'Próximo a vencer',
    urgent: 'Urgente',
    overdue: 'Vencido',
  }

  const formatDate = (date) => {
    if (!date) return ''
    const raw = date?.$date || date
    const d = new Date(raw)
    if (isNaN(d.getTime())) return ''
    const year = d.getUTCFullYear()
    const month = String(d.getUTCMonth() + 1).padStart(2, '0')
    const day = String(d.getUTCDate()).padStart(2, '0')
    return `${day}-${month}-${year}`
  }

  const exportToExcel = (requests) => {
    if (!requests) return

    const wb = XLSX.utils.book_new()

    // Título principal (A1:K1)
    const headerRow1 = ['CANAL ARSOPB+L — SOLICITUDES DE EJERCICIO DE DERECHOS', ...Array(10).fill('')]

    // Títulos de columnas
    const headerRow2 = [
      'N° de caso',
      'Derecho',
      'Titular',
      'Identificación',
      'Email',
      'Teléfono',
      'Fecha recepción',
      'Etapa',
      'Estado',
      'Plazo',
      'Responsable',
    ]

    const dataRows = requests.map(r => [
      r.caseNumber || '',
      rightLabels[r.rightCode] || r.rightCode || '',
      (r.titular && r.titular.fullName) || '',
      (r.titular && r.titular.identification) || '',
      (r.titular && r.titular.email) || '',
      (r.titular && r.titular.phone) || '',
      formatDate(r.createdAt),
      stageLabels[r.stage] || r.stage || '',
      statusLabels[r.status] || r.status || '',
      r.deadlineStatus ? (deadlineLabels[r.deadlineStatus.label] || '') : '',
      r.responsableName || '',
    ])

    const wsData = [headerRow1, headerRow2, ...dataRows]
    const ws = XLSX.utils.aoa_to_sheet(wsData)

    ws['!cols'] = [
      { wch: 20 }, // N° de caso
      { wch: 16 }, // Derecho
      { wch: 28 }, // Titular
      { wch: 18 }, // Identificación
      { wch: 30 }, // Email
      { wch: 16 }, // Teléfono
      { wch: 16 }, // Fecha recepción
      { wch: 22 }, // Etapa
      { wch: 14 }, // Estado
      { wch: 18 }, // Plazo
      { wch: 25 }, // Responsable
    ]

    if (!ws['!rows']) ws['!rows'] = []
    ws['!rows'][0] = { hpt: 25 }
    ws['!rows'][1] = { hpt: 30 }

    // Estilo de las filas de encabezado
    for (let R = 0; R <= 1; R++) {
      for (let C = 0; C <= 10; C++) {
        const address = XLSX.utils.encode_cell({ r: R, c: C })
        if (!ws[address]) continue
        ws[address].s = {
          fill: { fgColor: { rgb: '2F5496' } },
          font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 10 },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
          },
        }
      }
    }

    if (!ws['!merges']) ws['!merges'] = []
    ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } })

    XLSX.utils.book_append_sheet(wb, ws, 'ARSOPBL')

    const today = new Date().toISOString().split('T')[0]
    XLSX.writeFile(wb, `ARSOPBL_${today}.xlsx`)
  }

  return {
    exportToExcel,
  }
}
